import React, {useEffect, useState} from "react";
import {isEmpty} from "../util/is";
import Emitter from "../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../data/ConstantEventEmitter";
import {changeActionsTable} from "../util/functions";

const Tabs = ({tabs = [], defaultValue, setStateTab}) => {

    const [ state, setState ] = useState(defaultValue);

    const handleChangeTab = (value) => {
        setState(value);

        if(setStateTab != undefined){
            setStateTab(value);
        }
    }

    useEffect(() => {

        let resetState = false;

        for(let item of tabs){
            if(!item.show && item.value === state){
                resetState = true;
                break;
            }
        }

        if(resetState){
            setState(defaultValue);
        }

    }, [tabs])


    useEffect(() => {
      return () => {
        Emitter.off(ConstantEventEmitter.eventChangeTab);
      }
    },[])

    useEffect(() => {
      Emitter.on(ConstantEventEmitter.eventChangeTab, (value) => setState(value));
    }, [])


    return(
        <div>
            <div className="px-4 py-3">

                <ul id="myTab" role="tablist"
                    className="nav nav-tabs nav-pills flex-column flex-sm-row text-center bg-light border-0 rounded-nav">
                    {
                        tabs.map((item, index) => (
                            <li key={item.value} className="nav-item flex-sm-fill" style={{display: `${item.show ? 'list-item' : 'none'}`}}>
                                <div onClick={() => handleChangeTab(item.value)} id={`id${item.value}`}  data-toggle="tab" role="tab" aria-controls={item.value}
                                   aria-selected={state === item.value} style={{cursor: "pointer"}}
                                   className={`nav-link border-0 text-uppercase font-weight-bold ${state === item.value ? 'active' : ''}`}>
                                    {
                                        !isEmpty(item.icon) &&
                                            <i className={`mx-2 ${item.icon} fa-lg`}/>
                                    }
                                    {
                                        isEmpty(item.icon) &&
                                            <i className={`mx-2 fas fa-briefcase fa-lg`}/>
                                    }
                                    {item.text}
                                </div>
                            </li>
                        ))
                    }
                </ul>
                <div id="myTabContent" className="tab-content">

                    {
                        tabs.map((item, index) => (
                                    <div key={`keyContent${item.value}`} id={`${item.value}`} role="tabpanel" aria-labelledby={`id${item.value}`}
                                         className={state === item.value && item.show ? `tab-pane fade px-2 py-4 active show` : `tab-pane fade px-2 py-4`}>
                                        {
                                            item.component &&
                                            item.component
                                        }
                                        {
                                            !item.component &&
                                            <div>
                                                <p className="text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing
                                                    elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                                    enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                                    aliquip ex ea commodo consequat. Duis aute
                                                    irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                                                    nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                                    culpa qui officia deserunt mollit anim id est laborum.</p>
                                                <p className="text-muted mb-0">Lorem ipsum dolor sit amet, consectetur
                                                    adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                                                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                                    nisi ut aliquip ex ea commodo consequat. Duis aute
                                                    irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                                                    nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                                    culpa qui officia deserunt mollit anim id est laborum.</p>
                                            </div>
                                        }
                                    </div>
                        ))
                    }
                </div>

            </div>
        </div>
    )

}


export default Tabs;
